module.exports = __webpack_public_path__ + "static/56invgde-285cae22680014be297ef412ed52c822.gif";